module.exports = __webpack_public_path__ + "img/zl5.552a5f8c.png";